/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MonthlyDekitus.vue?vue&type=template&id=6ba3e8d4&scoped=true&"
import script from "./MonthlyDekitus.vue?vue&type=script&setup=true&lang=js&"
export * from "./MonthlyDekitus.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MonthlyDekitus.vue?vue&type=style&index=0&id=6ba3e8d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba3e8d4",
  null
  
)

export default component.exports